import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Icon,
  DialogTitle
} from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { makeStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';
import { addAlert } from '../../actions/alerts.action';
import { useMutation } from 'react-query';
import { deleteComment } from '../../api/objective/comment.api';

const useStyles = makeStyles(theme => ({
  title: {
    backgroundColor: 'white',
    color: '#252733'
  },
  errorIcon: {
    top: theme.spacing(0.3),
    right: theme.spacing(0.5),
    verticalAlign: 'middle',
    position: 'relative',
    color: 'crimson'
  },
  deleteBtn: {
    background: red['A200']
  }
}));

const DeleteDialog = ({ open, setOpen, commentId, objectiveId, onSubmitSuccess }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const deleteCommentMutation = useMutation(
    async () => {
      return await deleteComment({
        objectiveId,
        commentId
      });
    },
    {
      onSuccess: () => {
        onSubmitSuccess();
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog open={ open } onClose={ handleClose }>
        <DialogTitle className={ classes.title }>
          <Icon className={ classes.errorIcon }>
            <ErrorIcon/>
          </Icon>
          { t('comments.deleteDialog.title') }
        </DialogTitle>
        <DialogContent>
          { t('comments.deleteDialog.content') }
        </DialogContent>
        <DialogActions>
          <Button
            onClick={ deleteCommentMutation.mutate }
            variant="contained"
            className={ classes.deleteBtn }
          >
            { t('comments.deleteDialog.deleteBtn') }
          </Button>
          <Button
            onClick={ handleClose }
          >
            { t('comments.deleteDialog.cancelBtn') }
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteDialog;
